<template>
  <div class="pie-chart-card">
    <div class="card-header">
      <div class="card-header-left">
        <p class="card-header-title">{{title}}</p>
        <el-tooltip v-if="tooltip" effect="dark" :content="tooltip" placement="top" style="margin-left: 4px">
          <i class="QS-icon-question-outline"></i>
        </el-tooltip>
        <p class="card-header-dataDesc">{{dataDesc}}</p>
        <i class="separator"></i>
        <p class="card-header-dataUpdateTime">更新于{{dataUpdateTime}}</p>
      </div>
    </div>
    <div class="card-body">
      <div class="card-body-inner">
        <div class="total">
          <div class="total-title">{{totalTitle}}</div>
          <div class="total-value-wrapper">
            <span :class="{'total-value': true, pointer: !!this.dataClick}" @click="handleDataValueClick">{{totalNum}}</span>
            <span class="total-unit">{{unit}}</span>
          </div>
          <div class="data-change-situation-list" v-if="Array.isArray(ratioList) && ratioList.length">
            <p class="data-change-situation" v-for="(item, index) in ratioList" :key="index">
              <span class="situation-label">{{item.name}}</span>
              <i :class="{
                'situation-icon': true,
                increase: item.value > 0,
                decrease: item.value < 0
              }"></i>
              <span :class="{
                'situation-value': true,
                increase: item.value > 0,
                decrease: item.value < 0
              }">{{item.value === null || typeof item.value === 'undefined' ? '--' : (item.value * 100).toFixed(2).replace('-', '') + '%'}}</span>
            </p>
          </div>
        </div>
        <div ref="chart" class="echarts"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { convertNumber } from '@/utils/'

export default {
  props: {
    // 标题
    title: {
      type: String,
      default: '',
    },
    // // 数据名称
    // dataName: {
    //   type: String,
    //   default: '',
    // },
    // 提示语
    tooltip: {
      type: String,
      default: '',
    },
    // 数据描述
    dataDesc: {
      type: String,
      default: '',
    },
    // 数据更新时间
    dataUpdateTime: {
      type: String,
      default: '',
    },
    // 数据类型: number(数量) amount(金额)
    dataType: {
      type: String,
      default: 'number',
    },
    // 总和标题
    totalTitle: {
      type: String,
      default: '',
    },
    // 总和
    total: {
      type: [String, Number],
      default: '',
    },
    // 总和单位
    unit: {
      type: String,
      default: '',
    },
    // 环比/同比
    ratioList: {
      type: Array,
      default: () => [],
    },
    // 系列数据列表
    seriesData: {
      type: Array,
      default: () => [],
    },
    // 总数点击回调
    dataClick: {
      type: Function,
    },
    colorList: {
      type: Array,
      default: () => ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc', '#FF6565', '#38ACF4', '#C28A50', '#C86C48', '#6A9A9A', '#4D8B0F', '#4DC83D', '#BA53C8', '#CE20B7', '#6742EB', '#3866F4', '#F1A909', '#E59691', '#1BDBDB', '#84C443', '#F46422', '#A37FE7', '#FC52B8', '#0D85CF', '#AB3709', '#068B8B'],
    },
  },
  computed: {
    chartOption() {
      return {
        tooltip: {
          confine: true,
          trigger: 'item',
          backgroundColor: 'rgba(0,0,0,0.65)',
          borderColor: 'rgba(0,0,0,0.65)',
          formatter: (params) => {
            const { name, value, data, color } = params

            const _value = this.dataType === 'amount' ? convertNumber(value) : value

            const ratio = typeof data?.ratio !== 'undefined' ? `(${(data.ratio * 100).toFixed(2)}%)` : ''
            const ratioList = data?.ratioList || []
            const children = data?.children || []

            let html = `<div class="tooltip-inner">
                          <div class="tooltip-serie-row">
                            <div class="tooltip-serie-detail">
                              <i class="tooltip-serie-row-point" style="background: ${color};"></i>
                              <div class="tooltip-serie-name">${name}:</div>
                              <div class="tooltip-serie-data">
                                <span class="tooltip-serie-data-value">${_value}${this.unit}${ratio}</span>
                              </div>
                            </div>`

            if (ratioList.length > 0) {
              html += '<div class="tooltip-serie-data-change-situation-wrapper">'
              for (let i = 0; i < ratioList.length; i++) {
                const { name: ratioName, value: ratioValue } = ratioList[i]
                html += `<p class="tooltip-serie-data-change-situation">
                          <span class="tooltip-serie-situation-label">${ratioName}</span>
                          <i class="${`tooltip-serie-situation-icon ${ratioValue > 0 ? 'increase' : ''} ${ratioValue < 0 ? 'decrease' : ''}`}"></i>
                          <span class="${`tooltip-serie-situation-value ${ratioValue > 0 ? 'increase' : ''} ${ratioValue < 0 ? 'decrease' : ''}`}">${ratioValue === null || typeof ratioValue === 'undefined' ? '--' : `${(ratioValue * 100).toFixed(2).replace('-', '')}%`}</span>
                        </p>`
              }
              html += '</div>'
            }

            if (children.length > 0) {
              html += '<div class="tooltip-serie-row-list">'
              for (let i = 0; i < children.length; i++) {
                const { name: childName, value: childValue, ratio: childRatio, ratioList: childRatioList, unit = '' } = children[i]
                const _childRatio = typeof childRatio !== 'undefined' ? `(${(childRatio * 100).toFixed(2)}%)` : ''
                html += `<div class="tooltip-serie-row">
                          <div class="tooltip-serie-detail">
                            <i class="tooltip-serie-row-point"></i>
                            <div class="tooltip-serie-name">${childName}:</div>
                            <div class="tooltip-serie-data">
                              <span class="tooltip-serie-data-value">${childValue}${unit}${_childRatio}</span>
                            </div>
                          </div>`
                if (childRatioList.length > 0) {
                  html += '<div class="tooltip-serie-data-change-situation-wrapper">'
                  for (let j = 0; j < childRatioList.length; j++) {
                    const { name: childRatioName, value: childRatioValue } = childRatioList[j]
                    html += `<p class="tooltip-serie-data-change-situation">
                              <span class="tooltip-serie-situation-label">${childRatioName}</span>
                              <i class="${`tooltip-serie-situation-icon ${childRatioValue > 0 ? 'increase' : ''} ${childRatioValue < 0 ? 'decrease' : ''}`}"></i>
                              <span class="${`tooltip-serie-situation-value ${childRatioValue > 0 ? 'increase' : ''} ${childRatioValue < 0 ? 'decrease' : ''}`}">${childRatioValue === null || typeof childRatioValue === 'undefined' ? '--' : `${(childRatioValue * 100).toFixed(2).replace('-', '')}%`}</span>
                            </p>`
                  }
                  html += '</div>'
                }
                html += '</div>'
              }
              html += '</div>'
            }

            html += `</div>
                    </div>`

            return html
          },
        },
        legend: {
          top: 'center',
          right: '10',
          orient: 'vertical',
          // selectedMode: false,
          formatter: (name) => {
            const data = this.seriesData
            let value = ''
            let ratio = 0
            let children = ''
            for (let i = 0; i < data.length; i++) {
              if (data[i].name === name) {
                value = this.dataType === 'amount' ? convertNumber(data[i].value) : data[i].value
                ratio = data[i].ratio
                children = (data[i].children || []).map((item) => {
                  const { name: childName, value: childValue, ratio: childRatio } = item
                  const _childRatio = typeof childRatio !== 'undefined' ? `(${(childRatio * 100).toFixed(2)}%)` : ''
                  return `      ${childName}   ${childValue}${_childRatio}`
                }).join(' ')
              }
            }
            return `${name}  ${value}(${`${(Number(ratio) * 100).toFixed(2)}%`})${children}`
          },
        },
        series: [{
          type: 'pie',
          center: ['100', '55%'],
          radius: ['35%', '70%'],
          avoidLabelOverlap: false,
          minAngle: 3,
          label: {
            show: true,
            position: 'inside',
            formatter(param) {
              // 如果服务端返回百分比，则优先使用服务端返回值，如果未返回则使用饼图计算的百分比
              if (param?.data?.ratio) {
                return `${(Number(param.data.ratio) * 100).toFixed(2)}%`
              }
              return `${param.percent.toFixed(2)}%`
            },
          },
          labelLine: {
            show: true,
            smooth: true,
            length: 10,
            length2: 0,
          },
          data: this.seriesData,
        }],
        color: this.colorList,
      }
    },
    totalNum() {
      return this.dataType === 'amount' ? convertNumber(this.total) : this.total
    },
  },
  watch: {
    chartOption: {
      handler() {
        this.chart.setOption(this.chartOption, true)
      },
      deep: true,
      immediate: false,
    },
  },
  mounted() {
    this.init()
  },
  destroyed() {
    this.chart.dispose()
  },
  methods: {
    init() {
      const _this = this
      this.chart = echarts.init(this.$refs.chart)
      this.chart.setOption(this.chartOption)
      this.chart.on('legendselectchanged', function (params) {
        const option = this.getOption()
        option.legend[0].selected[params.name] = true
        this.setOption(option)

        const serie = _this.seriesData.find((item) => item.name === params.name)
        serie && serie.clickCallback && serie.clickCallback()
      })
      window.addEventListener('resize', () => {
        this.chart.resize()
      })
    },
    handleDataValueClick() {
      this.dataClick && this.dataClick()
    },
  },
}
</script>

<style lang="scss">
.pie-chart-card {
  .echarts {
    width: 100%;
    height: 242px;
  }
  .tooltip-inner {
    // padding: 16px;
    color: #fff;
    .tootip-title {
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    }
    .tooltip-serie-row-list {
      display: flex;
    }
    .tooltip-serie-row {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      // margin-top: 16px;
      .tooltip-serie-row-point {
        position: relative;
        // top: 3px;
        left: -4px;
        flex: none;
        width: 8px;
        height: 8px;
        border-radius: 5px;
      }
      .tooltip-serie-detail {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 8px;
        .tooltip-serie-name {
          font-size: 14px;
          font-weight: normal;
          line-height: 22px;
        }
        .tooltip-serie-data {
          .tooltip-serie-data-value {
            font-size: 14px;
            font-weight: normal;
            line-height: 22px;
          }
        }
      }
      .tooltip-serie-data-change-situation-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        .tooltip-serie-data-change-situation {
          flex: none;
          margin-left: 16px;
          .tooltip-serie-situation-label {
            font-size: 12px;
            font-weight: normal;
            line-height: 22px;
            color: #FFF
          }
          .tooltip-serie-situation-icon {
            display: inline-block;
            &.increase {
              position: relative;
              top: -1px;
              width: 10px;
              height: 7px;
              background: url('../../../../assets/img/ratio_up.png') 0 0 no-repeat;
              background-size: 100%;
            }
            &.decrease {
              position: relative;
              top: -1px;
              width: 10px;
              height: 7px;
              background: url('../../../../assets/img/ratio_down.png') 0 0 no-repeat;
              background-size: 100%;
            }
          }
          .tooltip-serie-situation-value {
            &.increase {
              font-size: 12px;
              font-weight: normal;
              line-height: 14px;
              color: #0FC570;
            }
            &.decrease {
              font-size: 12px;
              font-weight: normal;
              line-height: 14px;
              color: #EA0000;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.pie-chart-card {
  border-radius: 2px;
  overflow: hidden;
  .card-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 38px;
    padding: 8px 12px;
    background: #F8F8FA;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: -9px;
      content: '';
      width: 3px;
      height: 18px;
      background: #0256FF;
      border-radius: 10px;
    }
    .card-header-left {
      display: flex;
      align-items: center;
      .card-header-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 22px;
        color: #3D3D3D;
      }
      ::v-deep .QS-icon-question-outline {
        color: #C0C4CC;
      }
      .card-header-dataDesc {
        margin-left: 10px;
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
      .separator {
        width: 1px;
        height: 10px;
        margin: 0 6px;
        flex: none;
        background: #767676;
      }
      .card-header-dataUpdateTime {
        font-size: 12px;
        font-weight: normal;
        line-height: 22px;
        color: #767676;
      }
    }
    .card-header-right {

    }
  }
  .card-body {
    .card-body-inner {
      display: flex;
      flex-direction: column;
      // justify-content: center;
      // align-items: center;
      padding: 26px 32px 0 32px;
      border-left: 1px solid #ECEEF4;
      border-right: 1px solid #ECEEF4;
      border-bottom: 1px solid #ECEEF4;
      .total {
        .total-title {
          font-size: 14px;
          font-weight: normal;
          line-height: 22px;
          color: #3D3D3D;
        }
        .total-value-wrapper {
          display: flex;
          align-items: flex-end;
          margin-top: 4px;
          .total-value {
            font-size: 32px;
            font-weight: 600;
            line-height: 32px;
            color: #3D3D3D;
            &.pointer {
              cursor: pointer;
            }
          }
          .total-unit {
            position: relative;
            top: -2px;
            left: 4px;
            font-size: 14px;
            font-weight: normal;
            line-height: 14px;
            color: #3D3D3D;
          }
        }
      }
      .data-change-situation-list {
        display: flex;
        align-items: center;
        margin: 16px 0 0 0;
        .data-change-situation {
          margin: 0 12px 0 0;
          display: flex;
          align-items: center;
          // &:not(:last-child) {
          //   margin: 0 0 4px 0;
          // }
          .situation-label {
            flex: none;
            font-size: 12px;
            font-weight: normal;
            line-height: 22px;
            color: #767676;
          }
          .situation-icon {
            flex: none;
            margin: 0 2px 0 4px;
            &.increase {
              // position: relative;
              // top: 1px;
              width: 10px;
              height: 7px;
              background: url('../../../../assets/img/ratio_up.png') 0 0 no-repeat;
              background-size: 100%;
            }
            &.decrease {
              // position: relative;
              // top: 0px;
              width: 10px;
              height: 7px;
              background: url('../../../../assets/img/ratio_down.png') 0 0 no-repeat;
              background-size: 100%;
            }
          }
          .situation-value {
            &.increase {
              font-size: 12px;
              font-weight: normal;
              line-height: 14px;
              color: #0FC570;
            }
            &.decrease {
              font-size: 12px;
              font-weight: normal;
              line-height: 14px;
              color: #EA0000;
            }
          }
        }
      }
    }
  }
}
</style>
